import React from 'react';
import TimerIcon from '../../images/icons/IconTimer.svg';

const Timer = ({ submitTimerElapsed, getNoSubmitTimeout }) => (
  <div className="noSubmitTimerContainer">
    <img src={TimerIcon} />
    <div className="noSubmitTimerWrapper">
      <div className="noSubmitInner">
        <div className="fullTimer" />
        <div
          className="elapsedTimer"
          style={{ width: `${(submitTimerElapsed / getNoSubmitTimeout()) * 100}%` }}
        >
        </div>
      </div>
    </div>
  </div>
);

export default Timer;
